import { FC } from 'react';
import { FocusTriangle } from '../Navigation.styles';
import { NavLinkContainer } from './NavigationLink.styles';
import { NavigationLinkProps } from './NavigationLink.types';

const NavigationLink: FC<NavigationLinkProps> = ({ label, icon, onClick, to, offset, letterSpacing, testId }) => {
  return (
    <NavLinkContainer
      onClick={onClick}
      to={to}
      offset={offset}
      data-testid={testId ?? "NavigationLink"}
      letterSpacing={letterSpacing}
    >
      {icon}
      {label}
      <FocusTriangle />
    </NavLinkContainer>
  );
};

export default NavigationLink;
